import type { Sidekick } from "./types.js";

export const SIDEKICKS: Sidekick[] = [
  {
    name: "Ivy Luo",
    city: "深圳",
    base: "Shenzhen",
    abroad: "2 yrs in Singapore (work)",
    line: "Grew up above a Huaqiangbei repair shop, hikes the east coast most weekends. Knows which beach is empty on a Tuesday.",
    emoji: "\u{1F469}\u{1F3FB}\u200D\u{1F4BB}",
    persona: { E: 0.45, N: 0.6, F: 0.5, J: 0.75 },
    ax: { terrain: -0.2, era: 0.6, fame: -0.5, energy: 0.1, lens: -0.4 },
    u: { cul: 0.8, adv: 0.7, cra: 0.7, nig: 0.4, sho: 0.6 },
    family: 0.85,
    adds: {
      "\u6DF1\u5733":
        "The Chaoshan beef place her dad still queues for, and the tide window that makes the east coast walkable.",
    },
    fallbackAdds:
      "Knows which part of {city} is worth your one free morning — and which is a car park with a view.",
    prompts: [
      {
        q: "What everyone gets wrong about Shenzhen",
        a: "That it's only malls. The east half is coastline.",
      },
      { q: "The first place I take everyone", a: "Not the skyline. A beef hotpot table at 9pm." },
      { q: "You'll hear me say", a: "'Check the tide first. Then we go.'" },
    ],
    trust: {
      verified: true,
      langs: "EN fluent \u00B7 \u4E2D\u6587 native \u00B7 \u7CA4\u8BED",
      trips: 11,
      review:
        "\u201CShe rearranged our whole day around the tide and it was the best call of the trip.\u201D \u2014 Daniel, Berlin",
    },
    voice:
      "Hi! Saw you picked the coast \u2014 good instinct. Give me your dates and I'll check the tides.",
  },

  {
    name: "Yuqi Chen",
    city: "成都",
    base: "Chengdu",
    abroad: "3 yrs in Melbourne (uni)",
    line: "Knows every hotpot broth by heart. Will teach your kids panda facts in two languages.",
    emoji: "🧑🏻‍🦱",
    persona: { E: 0.7, N: 0.5, F: 0.9, J: 0.4 },
    ax: { terrain: -0.2, era: -0.2, fame: 0.2, energy: 0, lens: -0.5 },
    u: { cul: 1, adv: 0.3, cra: 0.5, nig: 0.4, sho: 0.2 },
    family: 0.9,
    adds: {
      成都: "The hotpot place with no English menu, and her aunt's tea table in People's Park.",
      重庆: "A noodle crawl through the alleys her college roommate grew up in.",
    },
    fallbackAdds: "Knows where {city} locals actually eat — and which queues to skip.",
    prompts: [
      { q: "The first place I take everyone", a: "The noodle stall with no sign. Trust me." },
      {
        q: "My unpopular opinion about my city",
        a: "Pandas are the appetizer. Teahouses are the main course.",
      },
      { q: "You'll hear me say", a: "'One more dish. Okay, two.'" },
    ],
    trust: {
      verified: true,
      langs: "EN native-level · 中文 native",
      trips: 14,
      review: "\u201CWe ate 14 meals in 4 days. Zero misses.\u201D — Rachel, SF",
    },
    voice: "Hey! Saw your route — that Chaoshan leg? Excellent decision. I know a guy.",
  },
  {
    name: "Leo Zhang",
    city: "上海",
    base: "Shanghai",
    abroad: "5 yrs in Toronto (product designer)",
    line: "Skyline photographer, vinyl-bar regular, knows which rooftop is free to enter.",
    emoji: "🧑🏻",
    persona: { E: 0.9, N: 0.7, F: 0.4, J: 0.3 },
    ax: { terrain: 0.9, era: 0.8, fame: 0.3, energy: 0.8, lens: 0.3 },
    u: { cul: 0.6, adv: 0.4, cra: 0.3, nig: 1, sho: 0.5 },
    family: 0.2,
    adds: {
      上海: "Rooftops with no cover charge, and the vinyl bar where the owner picks your record.",
      香港: "The dai pai dong his design clients took him to — cash only, worth it.",
    },
    fallbackAdds: "Finds the view in {city} that isn't on Instagram yet.",
    prompts: [
      {
        q: "The first place I take everyone",
        a: "A rooftop at 6:50pm. The skyline does the rest.",
      },
      {
        q: "My unpopular opinion about my city",
        a: "The Bund is the trailer. The lanes are the film.",
      },
      { q: "You'll hear me say", a: "'The light's better from up here.'" },
    ],
    trust: {
      verified: true,
      langs: "EN native-level · 中文 native",
      trips: 22,
      review:
        "\u201CHe rearranged our whole Shanghai night at 9pm. Best call ever.\u201D — Tom, London",
    },
    voice: "Okay so — pack one thing you can dance in. You'll thank me around midnight.",
  },
  {
    name: "Mei Lin",
    city: "桂林",
    base: "Guilin",
    abroad: "2 yrs in Bristol (masters)",
    line: "Grew up on the Li River. Slow-travel evangelist, unreasonably good at bargaining.",
    emoji: "👩🏻",
    persona: { E: 0.3, N: 0.8, F: 0.8, J: 0.5 },
    ax: { terrain: -0.9, era: -0.4, fame: -0.4, energy: -0.7, lens: 0.3 },
    u: { cul: 0.4, adv: 0.4, cra: 0.7, nig: 0.1, sho: 0.2 },
    family: 0.7,
    adds: {
      桂林: "Her uncle's bamboo raft — the stretch of river tour boats can't enter.",
      阳朔: "The village where she learned to cook beer fish. You'll cook it too.",
    },
    fallbackAdds: "Knows which {city} 'must-sees' to skip — and what to do instead.",
    prompts: [
      {
        q: "The first place I take everyone",
        a: "The riverbank at 7am, before the boats wake up.",
      },
      {
        q: "My unpopular opinion about my city",
        a: "The postcard view is real — but it's the third-best one.",
      },
      { q: "You'll hear me say", a: "'We're not lost. We're early.'" },
    ],
    trust: {
      verified: true,
      langs: "EN native-level · 中文 native",
      trips: 9,
      review: "\u201COur kids still talk about the raft.\u201D — the Hendersons, Austin",
    },
    voice: "No rush on the reply. I've been watching the river do nothing for an hour. It's great.",
  },
  {
    name: "Kai Wu",
    city: "北京",
    base: "Beijing",
    abroad: "4 yrs in Berlin (startup ops)",
    line: "History nerd with a motorbike. Does the Great Wall the way locals do it.",
    emoji: "🧔🏻",
    persona: { E: 0.6, N: 0.6, F: 0.3, J: 0.8 },
    ax: { terrain: -0.3, era: -0.8, fame: 0.1, energy: 0.1, lens: 0.4 },
    u: { cul: 0.5, adv: 0.7, cra: 0.8, nig: 0.5, sho: 0.1 },
    family: 0.5,
    adds: {
      北京: "The unrestored Wall section his hiking group climbs at sunrise.",
      西安: "A dumpling teacher, a bike route on the wall, and zero tourist restaurants.",
    },
    fallbackAdds: "Has a friend in {city}. He always has a friend.",
    prompts: [
      {
        q: "The first place I take everyone",
        a: "The Wall, the part without handrails or crowds.",
      },
      {
        q: "My unpopular opinion about my city",
        a: "Skip the duck queue. My guy is better and faster.",
      },
      { q: "You'll hear me say", a: "'This street is 700 years old. Anyway, breakfast.'" },
    ],
    trust: {
      verified: true,
      langs: "EN native-level · 中文 native",
      trips: 17,
      review:
        "\u201CFelt like visiting a friend who happens to know everything.\u201D — Priya, NYC",
    },
    voice: "Alarm at 4:40am. I know. You will forgive me by 6.",
  },
];
